<template>
  <input v-model="checked" type="checkbox" :checked="modelValue == trueValue" />
</template>

<script>
export default {
  name: 'j-check-box',
  props: {
    trueValue: [String, Number],
    falseValue: [String, Number],
    modelValue: { type: String, default: 'N' },
  },
  computed: {
    checked: {
      get() { return this.trueValue == this.modelValue },
      set(val) { this.$emit('update:modelValue', val ? this.trueValue : this.falseValue) }
    }
  }
}
</script>
